import script from "./Benefit.vue?vue&type=script&setup=true&lang=js"
export * from "./Benefit.vue?vue&type=script&setup=true&lang=js"

import "./Benefit.vue?vue&type=style&index=0&id=46f74fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f74fa0"]])

export default __exports__